/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbound_Field_Pickup_PhoneInputs */

const en_inbound_field_pickup_phone = /** @type {(inputs: Inbound_Field_Pickup_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pickup phone`)
};

/**
* | output |
* | --- |
* | "Pickup phone" |
*
* @param {Inbound_Field_Pickup_PhoneInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_field_pickup_phone = /** @type {((inputs?: Inbound_Field_Pickup_PhoneInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Field_Pickup_PhoneInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_field_pickup_phone(inputs)
});